import { Box, Text, NumberInput, Select, Group, Stack } from "@mantine/core";
import FileSelector from "./FileSelector";
import { groupTypes, busTypes } from "../get-a-quote/helpers/GetAQuoteHelpers";

export default function TripInfoBox({ formData, updateFormField }) {
  return (
    <Box
      sx={{
        backgroundColor: "#fafafa",
        borderRadius: "8px",
        maxWidth: 600,
        lineHeight: "120%",
      }}
    >
      <Stack spacing="md">
        <Text fw={600} fz="lg">
          Trip Information
        </Text>
        <NumberInput
          value={formData.pax}
          onChange={(v) => updateFormField("pax", v)}
          label="Est. number of passengers:"
          placeholder="e.g., 2"
          allowNegative={false}
          min={1}
          withAsterisk
        />
        {formData.pax !== null && formData.pax <= 5 && (
          <Text size={"sm"} c="red">
            Charter services ideally require 6 or more passengers
          </Text>
        )}
        <Group grow>
          <Select
            label="Group type"
            placeholder="Select Option"
            value={formData.groupType}
            onChange={(v) => updateFormField("groupType", v)}
            data={groupTypes}
            comboboxProps={{
              width: "auto",
              withinPortal: true,
              portalProps: { target: "#get-a-quote" },
            }}
            withAsterisk
          />
          <Select
            label="Preferred bus type"
            placeholder="Select Option"
            data={busTypes}
            value={formData.busType}
            onChange={(v) => updateFormField("busType", v)}
            comboboxProps={{
              width: "auto",
              position: "bottom-end",
              withinPortal: true,
              portalProps: { target: "#get-a-quote" },
            }}
            withAsterisk
          />
        </Group>
        <FileSelector updateFormField={updateFormField} />
        {formData.uploadedFiles.length > 0 && (
          <Text className="selected-file">
            Files selected:&nbsp;
            {formData.uploadedFiles?.map((file, index) => (
              <span key={index}>
                {file.filename}
                {index < formData.uploadedFiles?.length - 1 && ", "}
              </span>
            ))}
          </Text>
        )}
      </Stack>
    </Box>
  );
}
